import { SELECTOR, setSelector } from '@socialive/common';

const selectSplitSliceName = () => 'splitio';

setSelector(SELECTOR.SPLIT_SLICE_NAME, selectSplitSliceName);

export default selectSplitSliceName;
